/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
// We know and accept the deeper cyclical dependencies here
import type { ReactElement } from 'react';

import FooterLink from '../FooterLink/FooterLink';

import type { Strings, Link } from '../Footer';

import STYLES from './FooterLinkList.module.scss';

type Props = {
  parentId?: string;
  links: Link[];
  expanded: boolean;
  depth?: number;
  strings: Pick<Strings, 'expand' | 'close'>;
};

const FooterLinkList = ({
  depth = 0,
  expanded,
  links,
  parentId,
  strings,
}: Props): ReactElement | null =>
  links.length > 0 ? ( // some magic styling for having silky smooth transitions for our accordion
    <ul
      className={
        depth === 0 || expanded ? STYLES['footer-link-list'] : STYLES['footer-link-list--hidden']
      }
    >
      {links.map((link) => (
        <li
          key={parentId ? `${parentId}-${link.id}` : `${link.id}`}
          className={STYLES['footer-link-list__link']}
        >
          <FooterLink
            expanded={expanded}
            {...link}
            id={parentId ? `${parentId}-${link.id}` : `${link.id}`}
            depth={depth}
            strings={strings}
          />
        </li>
      ))}
    </ul>
  ) : null;

export default FooterLinkList;
